<template>
  <section class="layout" :style="{ minHeight: overHeight + 'px' }">
    <div class="layout-top">
      <mul-head class="layout-header">
        <template v-slot:logo>
          <div class="layout-header-logo">
            <router-link to="/">
              <img src="../assets/img/qz-logo.png" />
            </router-link>
          </div>
        </template>
        <template v-slot:nav>
          <mul-nav class="layout-header-nav" :navList="navList" />
        </template>
      </mul-head>
    </div>
    <div class="layout-view">
      <slot name="view"></slot>
    </div>
    <div class="layout-bot">
      <mul-foot class="layout-footer">
        <div slot="ba-copy">
          <div class="layout-footer-copy">
            <h3>创新、协作、责任、共赢</h3>
            <p>坚信科技的力量能够推动进步，不断投入研发，追求技术的领先</p>
          </div>
          <a class="copy" href="http://beian.miit.gov.cn/"
            >版权所有&copy;上海趋致信息技术有限公司
            &nbsp;&copy;沪ICP备2022024036号-3</a
          >
        </div>
      </mul-foot>
    </div>
  </section>
</template>

<script>
import mulHead from "@/components/Head.vue";
import mulNav from "@/components/Nav.vue";
import mulFoot from "@/components/Foot.vue";
export default {
  components: {
    mulHead,
    mulNav,
    mulFoot,
  },
  props: {},
  data() {
    return {
      overHeight: window.innerHeight,
      navList: [
        {
          path: "/",
          name: "home",
          text: "首页",
        },
        {
          path: "/about",
          name: "about",
          text: "关于",
        },
      ],
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
.layout {
  position: relative;
}
.layout-top {
  width: 100%;
}
.layout-header {
  height: 80px;
  padding: 22px 88px 23px;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}
.layout-header-logo {
  float: left;
  line-height: 36px;
}
.layout-header-logo img {
  width: 119px;
  height: 35px;
  float: left;
}
.layout-header-logo span {
  float: left;
  color: #fff;
  font-size: 24px;
  margin-left: 20px;
  font-weight: 500;
}
.layout-header-nav {
  float: right;
}
.layout-bot {
  width: 100%;
  position: absolute;
}
.layout-footer-copy {
  width: 100%;
  background-color: #2c2d33;
  color: rgba(255, 255, 255);
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  padding: 30px 0;
}
.layout-footer-copy h3{
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 18px;
  color: #FFFFFF;
  margin-bottom: 12px;
}
.layout-view {
  margin: 0 auto;
}
.copy {
  display: block;
  width: 100%;
  text-align: center;
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  padding: 20px 0;
}
</style>
